import { Button, List, Space, Stack, Title } from '@mantine/core';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { usePriceApi } from '../../../shared_hooks';
import { useEffect } from 'react';

export const Landing = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const price = usePriceApi();
  const params = new URLSearchParams(window.location.search);

  const deviceId = params.get('device_id');
  const paymentToken = params.get('token');

  if (deviceId) {
    localStorage.clear();
    localStorage.setItem('device_id', deviceId);
  }

  useEffect(() => {
    if (paymentToken) {
      localStorage.clear();
      void navigate(`/reports/overview?token=${paymentToken}`);
    }
  });

  return (
    <Stack>
      <Title order={1}>{t('welcome_title')}</Title>
      <p>{t('welcome_message')}</p>
      <Title order={3}>{t('offer_title')}</Title>
      <List icon={<CheckIcon />}>
        <List.Item>{t('offer_cardio')}</List.Item>
        <List.Item>{t('offer_fitness')}</List.Item>
        <List.Item>{t('offer_metabolism')}</List.Item>
      </List>
      <Title order={2}>
        {t('for')} {price}
      </Title>
      <Space h="md" />
      <Button
        fullWidth
        onClick={() => {
          void navigate('/consent');
        }}
      >
        {t('continue')}
      </Button>
    </Stack>
  );
};
